import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft, Facebook, Instagram, Globe } from 'lucide-react';
import AboutSection from '../components/AboutSection';

const AboutPage = () => {
  const navigate = useNavigate();
  const [language, setLanguage] = React.useState('en');

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#f7f5f2] to-white">
      {/* Header */}
      <header className="fixed top-0 w-full bg-white/90 backdrop-blur-md shadow-sm z-50">
        <div className="container mx-auto px-4 py-3 flex justify-between items-center">
          <div className="flex items-center gap-4">
            <Button
              variant="ghost"
              onClick={() => navigate('/')}
              className="flex items-center gap-2 text-[#8b1538] hover:text-[#6b0f2a]"
            >
              <ArrowLeft className="w-5 h-5" />
              <span className="hidden sm:inline">
                {language === 'en' ? 'Back to Home' : 'Volver al Inicio'}
              </span>
            </Button>
            
            <img 
              src="https://customer-assets.emergentagent.com/job_57e2dd96-4e50-451b-8abf-042890e7a51b/artifacts/m648krxt_Athena%27s%20Logo.png"
              alt="Athena's Online Shopping Services"
              className="h-12 w-auto object-contain cursor-pointer"
              onClick={() => navigate('/')}
            />
          </div>
          
          <div className="flex items-center gap-4">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setLanguage(language === 'en' ? 'es' : 'en')}
              className="flex items-center gap-2"
            >
              <Globe className="w-4 h-4" />
              {language === 'en' ? 'ES' : 'EN'}
            </Button>
            <a 
              href="https://www.facebook.com/profile.php?id=61584846392424" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[#8b1538] hover:text-[#6b0f2a] transition-colors"
            >
              <Facebook className="w-6 h-6" />
            </a>
            <a 
              href="https://www.instagram.com/athenasonlineshoppingservices/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[#8b1538] hover:text-[#6b0f2a] transition-colors"
            >
              <Instagram className="w-6 h-6" />
            </a>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <div className="pt-20">
        <AboutSection language={language} />
      </div>

      {/* Footer */}
      <footer className="bg-[#1e1919] text-white py-8 px-4">
        <div className="container mx-auto text-center">
          <div className="flex items-center justify-center mb-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_57e2dd96-4e50-451b-8abf-042890e7a51b/artifacts/m648krxt_Athena%27s%20Logo.png"
              alt="Athena's Online Shopping Services"
              className="h-24 w-auto object-contain"
            />
          </div>
          <div className="flex items-center justify-center gap-6 mb-4">
            <a 
              href="https://www.facebook.com/profile.php?id=61584846392424" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[#fad24b] hover:text-white transition-colors"
            >
              <Facebook className="w-6 h-6" />
            </a>
            <a 
              href="https://www.instagram.com/athenasonlineshoppingservices/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[#fad24b] hover:text-white transition-colors"
            >
              <Instagram className="w-6 h-6" />
            </a>
          </div>
          <p className="text-[#bbb5ae] text-sm mb-3">
            Business Hours: 10 AM - 9 PM (7 Days)
          </p>
          <div className="mb-4 text-sm space-y-1">
            <p className="text-[#bbb5ae]">
              Phone: <a href="tel:+5016735717" data-testid="footer-phone-link" className="text-[#fad24b] hover:text-white transition-colors">6735717</a>
            </p>
            <p className="text-[#bbb5ae]">
              WhatsApp: <a href="https://wa.me/5016735717" target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link" className="text-[#fad24b] hover:text-white transition-colors">Chat with us</a>
            </p>
            <p className="text-[#bbb5ae]">
              Email: <a href="mailto:athenasonlineshoppingservices@gmail.com" data-testid="footer-email-link" className="text-[#fad24b] hover:text-white transition-colors break-all">athenasonlineshoppingservices@gmail.com</a>
            </p>
            <p className="text-[#bbb5ae]">
              <a href="/privacy" data-testid="footer-privacy-link" className="text-[#fad24b] hover:text-white transition-colors">Privacy Policy</a>
            </p>
          </div>
          <p className="text-[#bbb5ae] text-sm">
            © {new Date().getFullYear()} Athena's Online Shopping Services. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default AboutPage;
